import { getField, updateField } from 'vuex-map-fields';
import FormContactUs from '../../api/form-contact-us';

// initial state
const state = {
};

// getters
const getters = {
    getField
};

// actions
const actions = {
    postSubmitForm({ commit, rootState }, { data, dealerId, clientToken, cb }) {
        FormContactUs.postSubmitForm((data) => {
            if (cb) {
                cb();
            }
        }, { data, dealerId, clientToken });
    },
};

// mutations
const mutations = {
    updateField,
    setStateValue(state, payload) {
        state[payload.key] = payload.value;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
